<template>
  <div>
    <h5 class="content-block">Input Absen Periode {{ bulan + "/" + tahun }}</h5>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <p class="text-muted font-weight-light">Periode Absen</p>
        <div class="row">
          <!-- <div class="editors"> -->
          <div class="editors-container">
            <div class="col">
              <DxSelectBox
                :dataSource="bulanSource"
                valueExpr="id"
                displayExpr="name"
                width="100%"
                label="Periode Bulan"
                placeholder="Periode Bulan"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                v-model="filters.bulan"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
            <div class="col" style="padding-left: 10px">
              <DxSelectBox
                :dataSource="tahunSource"
                width="100%"
                label="Periode Tahun"
                placeholder="Periode Tahun"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                v-model="filters.tahun"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>

            <div class="col" style="padding-left: 10px">
              <DxButton
                @click="validateFilter"
                text="Buat Daftar Absen"
                styling-mode="filled"
                type="default"
                class="validate"
                style="float: left"
              />

              <!-- <button class="btn btn-primary float-left mr-2">Button</button> -->
            </div>
          </div>
          <!-- </div> editors-->
        </div>
      </div>
    </div>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxDataGrid
          ref="dataGrid"
          :data-source="dataSource"
          :allow-column-reordering="true"
          :show-borders="true"
          key-expr="id"
          @editor-preparing="oneditorpreparing"
          :show-column-lines="false"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          @exporting="onExporting"
          :focused-row-enabled="true"
          :focused-row-index="0"
          @editing-start="editingStart"
        >
          <DxFilterRow :visible="true" />
          <dx-pager :show-page-size-selector="true" :show-info="true" />
          <DxPaging :enabled="true" :page-size="numberingPageSize" />
          <DxExport :enabled="true" :allow-export-selected-data="true" />
          <DxEditing
            :allow-updating="true"
            :allow-deleting="false"
            :allow-adding="false"
            mode="batch"
          />
          <!-- <DxEditing
            :allow-updating="true"
            :allow-adding="true"
            :allow-deleting="true"
            :select-text-on-edit-start="selectTextOnEditStart"
            :start-edit-action="startEditAction"
            mode="batch"
          /> -->
          <DxToolbar>
            <DxItem name="groupPanel" />
            <DxItem name="addRowButton" show-text="always" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
            <DxItem name="searchPanel" />
          </DxToolbar>

          <DxColumnFixing :enabled="true" />
          <DxColumn caption="id" data-field="id" />
          <DxColumn
            caption="#"
            data-field="created_at"
            cell-template="numberingTemplate"
            :allow-filtering="false"
            :allow-sorting="false"
            :fixed="true"
            fixed-position="left"
          />

          <template #numberingTemplate="{ data }">
            {{ numberingPageNumber * numberingPageSize + data.rowIndex + 1 }}
          </template>
          <DxColumn
            data-field="pegawai_id"
            caption="NIK"
            :fixed="true"
            fixed-position="left"
          >
            <!-- <DxLookup
              :data-source="pegawaiSource"
              value-expr="id"
              display-expr="nik"
            /> -->
          </DxColumn>
          <!-- <DxColumn data-field="pegawai_id" caption="Nama lookup">
            <DxLookup
              :data-source="pegawaiSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn> -->

          <DxColumn
            data-field="pegawai.nama"
            caption="Nama"
            :fixed="true"
            fixed-position="left"
          >
          </DxColumn>
          <DxColumn
            data-field="periode_absen"
            caption="Periode Absen"
            data-type="date"
            :display-format="'MM/yyyy'"
            :format="'MM/yyyy'"
            sort-order="desc"
            cell-template="periodeAbsenTemplate"
            :fixed="true"
            fixed-position="left"
          >
          </DxColumn>
          <template #periodeAbsenTemplate="{ data }">
            {{ formatMonth(data.text) }}
          </template>

          <DxColumn data-field="riwayatPekerjaan.cabang_id" caption="Cabang">
            <DxLookup
              :data-source="cabangSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn>
          <DxColumn
            data-field="riwayatPekerjaan.pegawai_status_id"
            caption="Status"
          >
            <DxLookup
              :data-source="pegawaiStatusSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn>

          <DxColumn data-field="riwayatPekerjaan.bagian_id" caption="Bagian">
            <DxLookup
              :data-source="bagianSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn>
          <DxColumn
            data-field="riwayatPekerjaan.sub_bagian_id"
            caption="Sub Bagian"
          >
            <DxLookup
              :data-source="subBagianSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn>
          <DxColumn
            data-field="riwayatPekerjaan.sub_bidang_id"
            caption="Sub Bidang"
          >
            <DxLookup
              :data-source="subBidangSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn>
          <DxColumn data-field="riwayatPekerjaan.seksi_id" caption="Seksi">
            <DxLookup
              :data-source="seksiSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn>
          <DxColumn data-field="hadir" caption="Hadir"></DxColumn>

          <DxColumn
            data-field="sakit"
            data-type="number"
            caption="Sakit"
            :set-cell-value="setCellValueSakit"
          ></DxColumn>
          <DxColumn
            data-field="ijin"
            data-type="number"
            caption="Ijin"
            :set-cell-value="setCellValueIjin"
          ></DxColumn>
          <DxColumn
            data-field="alpa"
            data-type="number"
            caption="Alpa"
            :set-cell-value="setCellValueAlpa"
          ></DxColumn>
          <DxColumn
            data-field="cuti"
            data-type="number"
            caption="Cuti"
            :set-cell-value="setCellValueCuti"
          ></DxColumn>
          <DxColumn
            data-field="tidak_hadir"
            data-type="number"
            caption="Tdk Hadir"
          ></DxColumn>
        </DxDataGrid>
      </div>
      current
      <li>input april absen based on data excel OK</li>
      <li>generate gaji using this absen</li>
      <li>compare gaji ori with generated gaji from system</li>

      next
      <li>
        menu daftar absen hanya bisa diedit untuk bulan sekarang dan jika gaji
        belum keluar
      </li>
      <li>menu generate gaji, check if absen exist for pegawai</li>
      <li>pas generate gaji, jml_tdk_hadir ambil dari table absen</li>
      <li>add download template for importing absen data</li>
      <li>add import menu for absen</li>
    </div>
  </div>
</template>

<style lang="scss"></style>

<script>
import axios from "axios";
import notify from "devextreme/ui/notify";
import { DxValidator, DxRequiredRule } from "devextreme-vue/validator";
import DxButton from "devextreme-vue/button";
import DxSelectBox from "devextreme-vue/select-box";
import ODataStore from "devextreme/data/odata/store";
import { DateTime } from "luxon";
import DataSource from "devextreme/data/data_source";
import _ from "lodash";
// import DxDropDownButton from "devextreme-vue/drop-down-button";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxColumnFixing,
  // DxSelection,
  DxExport,
  DxToolbar,
} from "devextreme-vue/data-grid";
// import { toHandlerKey } from "vue";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
//GAGAL
// DateTime.local().setLocale("id");
// console.log(DateTime.local().months);
// const months = DateTime.local().months;
// console.log(months);
const months = [
  { name: "Januari", id: 1 },
  { name: "Februari", id: 2 },
  { name: "Maret", id: 3 },
  { name: "April", id: 4 },
  { name: "Mei", id: 5 },
  { name: "Juni", id: 6 },
  { name: "Juli", id: 7 },
  { name: "Agustus", id: 8 },
  { name: "September", id: 9 },
  { name: "Oktober", id: 10 },
  { name: "November", id: 11 },
  { name: "Desember", id: 12 },
];

const currentYear = DateTime.now().toFormat("yyyy");
const currentMonth = DateTime.now().toFormat("M");
const years = [currentYear, Number(currentYear) + 1];

// console.log(currentMonth);

export default {
  components: {
    DxSelectBox,
    DxButton,
    DxValidator,
    DxRequiredRule,
    DxDataGrid,
    // eslint-disable-next-line
    DxColumn,
    DxPager,
    DxPaging,
    DxEditing,
    DxFilterRow,
    // eslint-disable-next-line
    DxLookup,
    DxColumnFixing,
    // DxSelection,
    DxExport,
    DxToolbar,
    // DxDropDownButton,
  },
  data() {
    return {
      bulan: currentMonth,
      tahun: currentYear,
      // selectTextOnEditStart: true,
      // startEditAction: "click",
      pegawaiStatusSource: new ODataStore({
        url: "http://127.0.0.1/odata/PegawaiStatuses",
        key: "id",
      }),
      // pegawaiSource: new ODataStore({
      //   url: "http://127.0.0.1/odata/SimpegPegawais",
      //   key: "id",
      // }),
      cabangSource: new ODataStore({
        url: "http://127.0.0.1/odata/Cabangs",
        key: "id",
      }),
      bagianSource: new ODataStore({
        url: "http://127.0.0.1/odata/Bagians",
        key: "id",
      }),
      subBagianSource: new ODataStore({
        url: "http://127.0.0.1/odata/SubBagians",
        key: "id",
      }),
      subBidangSource: new ODataStore({
        url: "http://127.0.0.1/odata/SubBidangs",
        key: "id",
      }),
      seksiSource: new ODataStore({
        url: "http://127.0.0.1/odata/Seksis",
        key: "id",
      }),
      golonganSource: new ODataStore({
        url: "http://127.0.0.1/odata/Golongans",
        key: "id",
      }),
      numberingPageSize: 10,
      numberingPageNumber: 0,
      // dataSource: [
      //   {
      //     ID: 0,
      //     pegawai_id: "",
      //   },
      // ],
      dataSource: null,
      filters: {
        bulan: Number(currentMonth),
        tahun: currentYear,
        pegawai_status_id: "",
        gaji_skema_id: "",
      },
      bulanSource: months,
      tahunSource: years,
      stylingMode: "outlined",
      //outlined, filled, underlined
      labelMode: "floating",

      skemaGajiSource: null,
    };
  },
  computed: {},
  async mounted() {},

  methods: {
    formatMonth(e) {
      const isoDateString = e.split("/").reverse().join("-") + "-01";
      const date = DateTime.fromISO(isoDateString).setLocale("id");
      return date.monthLong + " " + date.year;
    },
    setCellValueCuti(newData, value) {
      newData.cuti = value;
      // newData.tidak_hadir =
      //   this.nullOrZero(currentRowData.sakit) +
      //   this.nullOrZero(currentRowData.ijin) +
      //   this.nullOrZero(currentRowData.alpa) -
      //   this.nullOrZero(value);
    },
    setCellValueAlpa(newData, value, currentRowData) {
      newData.alpa = value;
      newData.tidak_hadir =
        this.nullOrZero(value) +
        this.nullOrZero(currentRowData.ijin) +
        this.nullOrZero(currentRowData.sakit);
    },
    setCellValueIjin(newData, value, currentRowData) {
      newData.ijin = value;
      newData.tidak_hadir =
        this.nullOrZero(value) +
        this.nullOrZero(currentRowData.sakit) +
        this.nullOrZero(currentRowData.alpa);
    },
    setCellValueSakit(newData, value, currentRowData) {
      newData.sakit = value;
      newData.tidak_hadir =
        this.nullOrZero(value) +
        this.nullOrZero(currentRowData.ijin) +
        this.nullOrZero(currentRowData.alpa);

      // console.log("SETVALUE SAKIT", currentRowData.sakit);
      // // newData.TotalPrice = currentRowData.Price * value;
      // console.log("newData hadir");
      // console.log("newData", newData);
      // console.log("value", value);
      // console.log("currentRowData", currentRowData);
    },
    nullOrZero(num) {
      if (num === null) return 0;
      return parseInt(num);
    },
    // keyDown(e) {
    //   console.log("keyDown", e);
    //   // console.log(e.component.getRowElement(e.event.currentTarget));
    // },

    // handleCellChanging(e) {
    //   console.log("handleCellChanging", e);
    //   const numHadir = this.nullOrZero(
    //     e.component.cellValue(e.newRowIndex, "hadir")
    //   );

    //   const numIjin = this.nullOrZero(
    //     e.component.cellValue(e.newRowIndex, "ijin")
    //   );
    //   const numSakit = this.nullOrZero(
    //     e.component.cellValue(e.newRowIndex, "sakit")
    //   );
    //   const numAlpa = this.nullOrZero(
    //     e.component.cellValue(e.newRowIndex, "alpa")
    //   );
    //   const numCuti = this.nullOrZero(
    //     e.component.cellValue(e.newRowIndex, "cuti")
    //   );
    // },
    // handleCellChanged(e) {
    //   console.log("handleCellChanged", e);
    //   const numHadir = this.nullOrZero(
    //     e.component.cellValue(e.rowIndex, "hadir")
    //   );

    //   const numIjin = this.nullOrZero(
    //     e.component.cellValue(e.rowIndex, "ijin")
    //   );
    //   const numSakit = this.nullOrZero(
    //     e.component.cellValue(e.rowIndex, "sakit")
    //   );
    //   const numAlpa = this.nullOrZero(
    //     e.component.cellValue(e.rowIndex, "alpa")
    //   );
    //   const numCuti = this.nullOrZero(
    //     e.component.cellValue(e.rowIndex, "cuti")
    //   );
    // },
    editingStart(e) {
      // console.log("editingStart", e);
      // console.log("getRowIndexByKey", e.component.getRowIndexByKey(e.key));
      // console.log(
      //   "getCellElement",
      //   e.component.getCellElement(e.component.getRowIndexByKey(e.key), "hadir")
      // );
      const element = e.component.getCellElement(
        e.component.getRowIndexByKey(e.key),
        "hadir"
      );

      e.component.focus(element);
      // const rowIndex = this.$refs.dataGrid.instance.getRowIndexByKey(e.key);
      // console.log("rowIndex", rowIndex);
      // const dataField = "hadir";
      // this.$nextTick(() => {
      //   // Get the row index using the key of the edited row
      //   const rowIndex = this.$refs.dataGrid.instance.getRowIndexByKey(e.key);

      //   // Focus the cell by retrieving the grid's underlying HTML element and using the focus method
      //   const cellElement = this.$refs.dataGrid.$el.querySelector(
      //     `td[aria-colindex="${dataField}"][aria-rowindex="${rowIndex}"]`
      //   );
      //   console.log("cellElement", cellElement);
      //   if (cellElement) {
      //     console.log("focus");
      //     cellElement.focus();
      //   }
      // });

      // this.$refs.dataGrid.$el
      //   .querySelector(
      //     `td[aria-colindex="${dataField}"][aria-rowindex="${rowIndex}"]`
      //   )
      //   .focus();
    },
    oneditorpreparing(e) {
      // if (e.parentType !== "filterRow") e.editorOptions.disabled = true;
      //klo pake ini malahan semuanya disable termasuk selection
      if (
        e.parentType === "dataRow" &&
        (e.dataField === "hadir" ||
          e.dataField === "sakit" ||
          e.dataField === "ijin" ||
          e.dataField === "alpa" ||
          e.dataField === "cuti")
      ) {
        e.editorOptions.disabled = false;
      }

      // if (
      //   e.parentType === "dataRow" &&
      //   (e.dataField === "pegawai.nama" ||
      //     e.dataField === "pegawai_id" ||
      //     e.dataField === "riwayatPekerjaan.cabang_id" ||
      //     e.dataField === "riwayatPekerjaan.bagian_id" ||
      //     e.dataField === "riwayatPekerjaan.sub_bagian_id" ||
      //     e.dataField === "riwayatPekerjaan.seksi_id")
      // ) {
      //   console.log("adalah datarow");
      //   console.log(e.dataField);
      //   e.editorOptions.disabled = true;
      // }

      return;
      // if (!e.row.isNewRow) e.editorOptions.disabled = true;
      // e.parentType === "dataRow" &&
      // e.dataField !== "pegawai_id" &&
      // e.dataField !== "riwayatPekerjaan.cabang_id" &&
      // e.dataField !== "riwayatPekerjaan.bagian_id" &&
      // e.dataField !== "riwayatPekerjaan.sub_bagian_id" &&
      // e.dataField !== "riwayatPekerjaan.seksi_id"
    },
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Gaji");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Gaji Pegawai " +
              this.filters.pegawai_status_id +
              " Periode Bulan " +
              this.filters.bulan +
              " " +
              this.filters.tahun +
              ".xlsx"
          );
        });
      });
      e.cancel = true;
    },

    onPageChanged(e, gridRef) {
      if (e.fullName == "paging.pageIndex") {
        this.numberingPageSize = this.$refs[gridRef].instance.pageSize();
        this.numberingPageNumber = e.value;
      }
    },

    validateFilter(e) {
      const result = e.validationGroup.validate();

      if (!result.isValid) return 0;

      // this.getAbsen();
      // return 0;
      var check = new ODataStore({
        url:
          "http://127.0.0.1/odata/AbsenBulans?$filter=month(periode_absen) eq " +
          this.filters.bulan +
          " and year(periode_absen) eq " +
          this.filters.tahun +
          "&$top=1",
        key: "id",
        version: 4,
        beforeSend: function (e) {
          e.headers = {
            "odata-version": "4.0",
          };
        },
      });
      check.totalCount().then(
        (data) => {
          if (data > 0) {
            // alert("INPUT ABSEN PADA PERIODE INI SUDAH DILAKSANAKAN");
            notify("INPUT ABSEN PADA PERIODE INI SUDAH DILAKSANAKAN", "error");
          } else {
            //generate gaji!!
            this.generateAbsen();
          }
        },
        (error) => {
          console.log(error);
        }
      );

      //tambahkan limit, tidak boleh generate gaji yang sudah digenerate!
    },

    async generateAbsen() {
      const config = {
        headers: {
          "content-type": "application/json",
        },
      };
      var data = {
        bulan: this.filters.bulan,
        tahun: this.filters.tahun,
      };
      await axios
        .post("http://127.0.0.1/api/absen_bulan_input", data, config)
        .then((response) => {
          notify(response.data.message, "success");
          // console.log(response);
          this.getAbsen();
        })
        .catch((error) => {
          console.log(error);
          notify("Gagal Generate Absen", "error");
        });
    },

    async getAbsen() {
      this.dataSource = new DataSource({
        store: new ODataStore({
          // ODataStore is configured here
          url: "http://127.0.0.1/odata/AbsenBulans",
          key: "id",
          version: 4,
          beforeSend: function (e) {
            e.headers = {
              "odata-version": "4.0",
            };
            if (hasFilterNestedTable(e.params.$filter)) {
              e.params.$filter = convertDatagridFilterNested(
                e.params.$filter,
                "riwayatPekerjaan"
              );
            }
            if (hasFilterNestedTablePegawai(e.params.$filter)) {
              e.params.$filter = convertDatagridFilterNestedContains(
                e.params.$filter
              );
            }
          },
        }),
        expand: ["riwayatPekerjaan", "pegawai"],
        filter: [
          [
            "periode_absen",
            this.filters.tahun + "-" + this.filters.bulan + "-01",
          ],
        ],
      });
    },
  },
};

function hasFilterNestedTable(str) {
  return (
    _.includes(str, "/") ||
    _.includes(str, "[") ||
    _.includes(str, "]") ||
    _.includes(str, "riwayatPekerjaan/") ||
    _.includes(str, "pegawaiGajiDetails/") ||
    _.includes(str, "pegawai/")
  );
}

function hasFilterNestedTablePegawai(str) {
  return _.includes(str, "pegawai/");
}

function convertDatagridFilterNested(filter, regVar) {
  var regex = new RegExp(`\\(${regVar}\\/[^)]+\\)`, "g");
  var occurrences = filter.match(regex);
  if (occurrences != null) {
    //biar dapat ['(pegawaiGajiDetails[0]/jml eq 23)', '(pegawaiGajiDetails[1]/jml eq 23)']
    var modifiedArr = occurrences.map((str) => {
      var modifiedString = str
        .replace(/\[\d+\]/g, "")
        .replace(
          new RegExp(`(${regVar}\\/)(.+)`),
          (match, capture1, capture2) => `${capture1}any(s:s/${capture2}`
        );
      return modifiedString + ")";
    });

    occurrences.forEach((extracted, index) => {
      filter = filter.replace(extracted, modifiedArr[index]);
    });
  }
  return filter;
}

function convertDatagridFilterNestedContains(filter) {
  // filter.replace(
  //   /contains\(tolower\(pegawai\/([^\)]+)\),'([^']+)'/,
  //   "pegawai/any(s:(contains(tolower(s/$1),'$2')))"
  // );
  const searchTerm = filter.match(
    /contains\(tolower\(pegawai\/nama\),'([^']+)'/
  )[1];

  // const replacedString = filter
  //   .replace(
  //     /contains\(tolower\(pegawai\/nama\),'([^']+)'/,
  //     `pegawai/any(s:(contains(tolower(s/nama),'${searchTerm}')))`
  //   )
  //   .replace(/(\(\(periode_absen eq ')([^']+)(\)\))/, `$1${searchTerm}$3`);

  const replacedString = filter.replace(
    /contains\(tolower\(pegawai\/nama\),'([^']+)'/,
    `pegawai/any(s:(contains(tolower(s/nama),'${searchTerm}'))`
  );
  return replacedString;
}
// return filter;
</script>
